module.exports = __webpack_public_path__ + "img/slp-logo.1866881c.svg";